import { EXCHANGE_RATES, isPreferredCurrency } from '~/constants/currency';

const formatCurrency = (
  amount: number | string | undefined = 0,
  {
    currency,
    notation,
    currencyDisplay,
    removeSign = false,
  }: Intl.NumberFormatOptions & {
    removeSign?: boolean;
  },
) => {
  const result = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    currencyDisplay,
    trailingZeroDisplay: 'stripIfInteger',
    notation,
  })
    .format(Number(amount))
    .replaceAll(',', ' ')
    .replace(/^(\D+)/, '$1 ')
    .replace(/\s+/, ' ');

  if (removeSign) {
    return result.replace(currency!, '');
  }

  return result;
};

const aedFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  notation: 'compact',
  maximumFractionDigits: 3,
});

export const formatPrice = (price: string | number | undefined): string => {
  if (!price) return '0';
  return aedFormatter.format(Number(price));
};

export const convertCurrency = (amount: number, fromCurrency: string, toCurrency: string): number => {
  if (fromCurrency === toCurrency) return amount;
  const rate =
    isPreferredCurrency(fromCurrency) && isPreferredCurrency(toCurrency)
      ? (EXCHANGE_RATES[fromCurrency][toCurrency] ?? 1)
      : 1;
  return amount * rate;
};

export default formatCurrency;
